import React from "react";
import { Box, Typography } from "@mui/material";
import {
  conversationBodyStyles,
  conversationFooterStyles,
  conversationSectionStyles,
  panelRootStyles,
  panelTitleStyles,
} from "./styles";

export type AsyncRoleplaySessionStatusLabel =
  | "Ready"
  | "Recording"
  | "Uploading"
  | "Processing"
  | "Transcribing"
  | "Finishing"
  | "Finished"
  | "Time limit"
  | "Report failed";

interface AsyncRoleplaySessionPanelProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const AsyncRoleplaySessionPanel: React.FC<
  AsyncRoleplaySessionPanelProps
> = ({ children, footer }) => {
  return (
    <Box sx={panelRootStyles} component="aside" aria-label="Conversation">
      <Box sx={conversationSectionStyles}>
        <Typography sx={panelTitleStyles}>Conversation</Typography>
        <Box sx={conversationBodyStyles}>{children}</Box>
        {footer ? <Box sx={conversationFooterStyles}>{footer}</Box> : null}
      </Box>
    </Box>
  );
};
